import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { ContentElement, ContentStatusEnum, GridCell, RowCell, SectionData } from '@urbannex/storethemes';
import { SectionEditorStoreService } from '../section-editor-dialog/section-editor-store.service';
import { Subject } from 'rxjs';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { take, takeUntil } from 'rxjs/operators';
import { CssServicesService } from '../../../services/css-services.service';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { EditState } from '../../../model';

@Component({
  selector: 'kve-color-picker-popover',
  templateUrl: './color-picker-popover.component.html',
  styleUrls: ['./color-picker-popover.component.scss']
})
export class ColorPickerPopoverComponent implements OnInit {
  color: string = "#222b45";
  colors: any[];
  content: ContentElement;
  /**
   * Target to set the color for.
   * Options: content, self, parent, container, cell, section, page
   */
  target: string;
  /**
   * Property to set the color for.
   * Options: background,border, text
   */
  property: string;
  /**
   * Service to use for updating the color.
   * Options: sectionEditStore, cellEditorStore
   */
  /**
   * Service to use for updating the color.
   * Options: sectionEditStore, cellEditorStore
   * If not defined and the target is defined the target will be used to determine the service.
   * If neither is defined the color will be set on the sectionBuilderStore
   */
  service: string;
  textColor: string;
  status: ContentStatusEnum;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private cellEditorStoreService: CellEditorStoreService,
    private sectionEditorStoreService: SectionEditorStoreService,
    private sectionBuilderStoreService: SectionBuilderStoreService,
    private communicator: IframeCommunicationService,
    private cssServicesService: CssServicesService) { }

  ngOnInit(): void {
    // Set defaults
    // Set default property if not defined
    this.property = this.property ? this.property : "text";
    this.target = this.target ? this.target : "content";
    this.service = this.service ? this.service : "sectionEditorStoreService";
    console.log(this.color);

    this.cssServicesService.getTextColor().subscribe(color => {
      this.textColor = color;
      console.log(this.textColor);
      console.log(this.colors);
    })
    if (this.color == undefined) {
      this.color = this.content.color ? this.content.color : this.textColor;
    }
    console.log(this.color);
    console.log(this.content);
    console.log(this.target);
    console.log(this.property);
    console.log(this.service);

    this.communicator.receive('txtColor').pipe(takeUntil(this.destroy$))
      .subscribe(payload => {
        const txtColor = payload.data
        console.log(txtColor)
      });
    if (this.colors == undefined || this.colors.length == 0) {
      this.setColors();
    }
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING);
  }

  handleChangeComplete(e) {
    // console.log(this.content);
    console.log(e);
    this.sectionBuilderStoreService.updateEditState(EditState.UPDATED);
    /* this.color = e.color.hex;
    switch (this.content.selector) {
      case "header":
        if(this.target != undefined){
          this.cellEditorStoreService.updateHeaderTxtColor(this.color);
        }else{
          if(this.target == "parent"){
            if(this.property != undefined && this.property == "background"){
              this.cellEditorStoreService.updateHdrParBgColor(this.color)
            }
          }
        }
        break;
      case "footer":
        if(this.target != undefined){
          this.cellEditorStoreService.updateFooterTxtColor(this.color);
        }else{
          if(this.target == "parent"){
            if(this.property != undefined && this.property == "background"){
              this.cellEditorStoreService.updateFtrParBgColor(this.color)
            }
          }
        }

        break;
      case "banner-text":
        if(this.target != undefined){
          this.cellEditorStoreService.updateTxtColor(this.color);
        }else{
          if(this.target == "parent"){
            if(this.property != undefined && this.property == "background"){
              this.cellEditorStoreService.updateTxtParBgColor(this.color)
            }
          }
        }

      default:
        break;
    } */


  }
  handleSectionColorChange() {
    console.log("Handling cell color change for color: " + this.color)
    // Handle the target
    if (!this.target) {
      throw new Error("Target has not been specified for sectionEditorService color update")
    }
    // Get the sectionData object
    let sectionData: SectionData;
    this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(_sectionData => {
      sectionData = _sectionData;
    })
    switch (this.target) {
      case "self":
      case "section":
        if (sectionData != undefined) {
          if (!this.property) {
            throw new Error("Property not specified")
          }
          switch (this.property) {
            case "border":
              let borderString;
              borderString = sectionData.border ? sectionData.border : "";
              if (borderString != "") {
                this.updateBorderColor(borderString, this.color)
              }
              break;
            case "background":
              this.sectionEditorStoreService.updateSectionData({ ...sectionData, bgColor: this.color })
              break;
            case "text":
              this.sectionEditorStoreService.updateSectionData({ ...sectionData, color: this.color })
              break

            default:
              break;
          }
        }
        break;
      case "content":
      case "contentElement":
      case "title":
        let content: ContentElement = sectionData.title;
        if (content != undefined) {
          switch (this.property) {
            case "border":
              let borderString;
              borderString = content.border ? content.border : "";
              if (borderString != "") {
                borderString = this.updateBorderColor(borderString, this.color)
              }
              content = { ...content, border: borderString };
              this.sectionEditorStoreService.updateTitle({ ...content })
              break;
            case "background":
              content = { ...content, background: this.color }
              this.sectionEditorStoreService.updateTitle({ ...content })
              break;
            case "text":
              content = { ...content, color: this.color }
              this.sectionEditorStoreService.updateTitle({ ...content })
              break;

            default:
              break;
          }
        }
        break;

      default:
        break;
    }
  }
  handleCellColorChange() {
    console.log("Executing cell color change")
    // Handle the target
    /* if(!this.target){
      throw new Error("Target has not been specified for cellEditorService color update")
    } */
    // Get the selectedCell object
    let selectedCell: GridCell | RowCell;
    this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
      if (cell) {
        selectedCell = cell;
      }
    })
    if (selectedCell) {
      console.log(selectedCell)
      let content;
      switch (this.target) {
        case "cell":
        case "self":
          switch (this.property) {
            case "border":
              let borderString = selectedCell.border ? selectedCell.border : "";
              if (borderString != "") {
                borderString = this.updateBorderColor(borderString, this.color)
              }
              console.log("cell-editor-store.service.ts - updating selected cell border: " + { ...selectedCell, border: borderString });
              this.cellEditorStoreService.updateSelectedCell({ ...selectedCell, border: borderString })
              break;
            case "background":
              console.log("cell-editor-store.service.ts - updating selected cell background: " + { ...selectedCell, bgColor: this.color });
              this.cellEditorStoreService.updateSelectedCell({ ...selectedCell, bgColor: this.color })
              break;
            case "text":
              console.log("cell-editor-store.service.ts - updating selected cell text: " + { ...selectedCell, color: this.color });
              this.cellEditorStoreService.updateSelectedCell({ ...selectedCell, color: this.color })
              break;

            default:
              break;
          }
          break;
        case "content":
        case "contentElement":
          console.log("Hitting content target")
          this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(_content => {
            if (_content) {
              content = _content;
            }
          })
          if (content != undefined) {
            console.log(content)
            switch (this.property) {
              case "border":
                let borderString = content.border ? content.border : "";
                if (borderString != "") {
                  borderString = this.updateBorderColor(borderString, this.color)
                  const updatedContent = { ...content, border: borderString };
                  this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent)
                }
                break;
              case "background":
                this.cellEditorStoreService.updateActiveSelectorAndSelectedCell({ ...content, background: this.color })
                break;
              case "text":
                this.cellEditorStoreService.updateActiveSelectorAndSelectedCell({ ...content, color: this.color })
                break;

              default:
                break;
            }
          }
          break;
        case "parent":
          console.log("Hitting parent target: " + this.target + " with property: " + this.property)
          this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe(_content => {
            if (_content) {
              content = _content;
            }
          })
          if (content != undefined) {
            console.log(content)
            switch (this.property) {
              case "border":
                let borderString = content.parentBorder ? content.parentBorder : "";
                if (borderString != "") {
                  borderString = this.updateBorderColor(borderString, this.color)
                  const updatedContent = { ...content, parentBorder: borderString };
                  this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent)
                }
                break;
              case "background":
                console.log("Hitting parent background")
                const updatedContent = { ...content, parentBackground: this.color };
                this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent)
                break;
              default:
                break;
            }
          }
          break;

        default:
          break;
      }
    }

  }
  handleColorPick(e): void {
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    console.log(e);
    if (e.color.rgb.a < 1) {
      this.color = "rgb(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.color.rgb.a + ")";
    } else {
      this.color = e.color.hex;
    }
    console.log("Service: ", this.service, "Target: ", this.target, " Property: ", this.property);
    // Handle color change for content elements
    // At this stage we have the service, target and property defined
    /**
     *  Sort out the issue with content - where the target is content
     * The issue arises because updating content element color properties can be handeled in both section and cell context
     *
     * */
    /* if(!this.service){
      throw new Error('Service must be specified');
    } */
    switch (this.service) {
      case "sectionEditorStoreService":
        this.handleSectionColorChange()
        break;
      case "cellEditorStoreService":
        console.log("Hit cellEditorStoreService")
        this.handleCellColorChange()
        break;

      default:
        console.log("Hit Error with no appropriate service found.  Instead found: " + this.service)
        throw new Error('Service specified but incorrectly')
        break;
    }
    /* if(this.service === "sectionEditorStoreService" || this.service === "cellEditorStoreService" && (this.target === "content" || this.target === "contentElement")){
      console.log("Section Editor Store Service color change");
      if(this.content == undefined || this.content == null){
        console.log("No content element defined - cannot set color");
        return
      }else{
        this.handleContentColorChange(this.service,this.content)
      }
    }else if(this.target !== "content"){
      this.handleContainerColorChange(this.service,this.property)
    } */
    // return

  }

  handleContentColorChange(service: string, content: ContentElement) {
    console.log({ service: service, content: content, property: this.property });
    // Handle color change for property first
    switch (this.property) {
      case "background":
        console.log("Handling bacxkground")
        content = { ...content, background: this.color }
        break;
      case "border":
        content = { ...content, borderColor: this.color }
        break;
      case "text":
        content = { ...content, color: this.color }
        break;
      default:
        content = { ...content, color: this.color }
        break;
    }
    // Handle the update using the service
    this.content = { ...content }
    switch (service) {
      case 'sectionEditorStoreService':
      case 'sectionStore':
        console.log("Section Editor Store Service color change");
        this.sectionEditorStoreService.updateTitle({ ...this.content })
        break;
      case 'cellEditorStoreService':

        this.cellEditorStoreService.updateActiveSelectorAndSelectedCell({ ...this.content });
        break;
      case 'sectionBuilderStoreService':
        this.sectionBuilderStoreService.updateContent({ ...this.content });
        break;
      default:
        console.log("No service defined for color change");
        break;
    }

  }

  handleContainerColorChange(service: string, property: string) {
    console.log("Handling container color change for: ", service, property);
    switch (property) {
      case "background":
        if (service === "sectionEditorStoreService" || service === "sectionStore") {
          this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
            sectionData.bgColor = this.color;
            sectionData = { ...sectionData, bgColor: this.color }
            this.sectionEditorStoreService.updateSectionData(sectionData)
          })
        } else if (service === "cellEditorStoreService") {
          this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
            cell = { ...cell, bgColor: this.color }
            console.log("cell-editor-store.service.ts - updating selected cell bgColor: " + cell);
            this.cellEditorStoreService.updateSelectedCell(cell);
          })
        }
        break;
      case "border":
        if (service === "sectionEditorStoreService" || service === "sectionStore") {
          this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
            sectionData = { ...sectionData, borderColor: this.color }
            this.sectionEditorStoreService.updateSectionData(sectionData)
          })
        } else if (service === "cellEditorStoreService") {
          this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
            cell = { ...cell, borderColor: this.color }
            console.log("cell-editor-store.service.ts - updating selected cell borderColor: " + cell);
            this.cellEditorStoreService.updateSelectedCell(cell);
          })
        }
        break;
      case "text":
        if (service === "sectionEditorStoreService" || service === "sectionStore") {
          this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
            sectionData = { ...sectionData, color: this.color }
            this.sectionEditorStoreService.updateSectionData(sectionData)
          })

        } else if (service === "cellEditorStoreService") {
          this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
            cell = { ...cell, color: this.color }
            console.log("cell-editor-store.service.ts - updating selected cell color: " + cell);
            this.cellEditorStoreService.updateSelectedCell(cell);
          })
        }
        break;
    }

  }

  resolveContentElement(status: ContentStatusEnum): ContentElement {
    console.log(status);
    let contentElement;
    if (status === "Initial Draft") {
      this.sectionBuilderStoreService.selectedCell$.subscribe((cell: GridCell | RowCell) => {
        const contentElements = cell.contentElements;
        contentElement = contentElements.find(element => element.elId == this.content.elId);
      })
    } else {
      this.cellEditorStoreService.contentElements$.subscribe((contentElements: ContentElement[]) => {
        contentElement = contentElements.find(element => element.elId == this.content.elId);
      })
    }
    return contentElement
  }
  /**
   * Sets the colors for the color picker if not already set.
   * This method can be used to fetch colors from a service or define them statically.
   */
  setColors(): void {
    const bgBasic: string[] = [];
    const bgPrimary: string[] = [];
    const bgAlt: string[] = [];
    const primaryColors: string[] = [];
    this.cssServicesService.getBgColors().pipe(take(1)).subscribe((colorKV: any[]) => {
      // console.log(colorKV);
      colorKV.forEach((colorObj, i) => {
        if (i < 4) {
          bgBasic.push(colorObj.val)
        } else if (i > 3 && i < 8) {
          bgPrimary.push(colorObj.val)
        } else if (i > 7) {
          bgAlt.push(colorObj.val)
        }

      })
      this.cssServicesService.getPmColors().pipe(take(1))
        .subscribe((colorKV: any[]) => {
          // console.log(colorKV)
          colorKV.forEach((colorObj) => {
            primaryColors.push(colorObj.val)
          })
          this.colors = bgBasic.concat(primaryColors).concat(bgAlt);
          console.log(this.colors)
        })
    });


  }
  handleColorChange(property: string, target: string, service: string): void {
    console.log("Handling property color change for: ", property, target, service);

    // 1. Use service to update the color
    switch (service) {
      case 'sectionEditorStoreService':
      case 'sectionStore':
      case 'section':
        // Use the target first - self or content
        // 1. If the target is self
        if (target == "self") {
          if (property == "background" || property == "bgColor" || property == "bgcolor") { }
          this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
            if (property == "background") {
              sectionData.bgColor = this.color;
              sectionData = { ...sectionData, bgColor: this.color }
            } else if (property == "border") {
              sectionData.borderColor = this.color;
              sectionData = { ...sectionData, borderColor: this.color }
              console.log("There is no property defined for section color change", this.color);
            } else if (property == "text") {
              sectionData.color = this.color
              sectionData = { ...sectionData, color: this.color }
            }
            this.sectionEditorStoreService.updateSectionData(sectionData)
          })
        } else {
          if (this.content != undefined) {
            // update the content property update
            this.content = { ...this.handlePropertyColorChange(property, this.content) };
            console.log(this.content);
            this.sectionEditorStoreService.updateTitle(this.content)
          }
        }

        // 2.If the target is not self

        // Options: background, border, text, content
        // If the property is content set the color of the contentElement which for section is the title



        // this.sectionEditorStoreService.setColor(this.color);
        break;
      case 'cellEditorStore':
    }
    if (this.content != undefined && this.content != null && this.content.elId != undefined && this.content.elId != "") {
      this.content = this.handlePropertyColorChange(property, this.content);
      console.log(this.target)
      // 2. Select gthe service for update
      switch (service) {
        case 'sectionEditStore':
        case 'sectionStore':
        case 'section':
          this.sectionEditorStoreService.updateTitle(this.content)
          // this.sectionEditorStoreService.setColor(this.color);
          break;
        case 'cellEditorStore':
        case 'cell':
          this.cellEditorStoreService.updateActiveSelector(this.content);
          break;
        case 'sectionBuilderStore':
          this.sectionBuilderStoreService.updateContent(this.content);
          break;
        default:
          console.log("No service defined for color change");
          break;
      }
    } else if (target != undefined && target != "") {
      // Handle color change for target when there is no contentElement
      console.log("No content element - updateing through target", target);
      switch (target) {
        case 'cell':
          console.log("Cell updated needds code")
          /* this.cellEditorStoreService.selectedCell$.pipe(take(1)).subscribe(cell => {
            if(this.property != undefined && this.property == "background"){
              cell.bgColor = this.color;
            }else if(this.property != undefined && this.property == "border"){
              cell.borderColor = this.color;
            }else if(this.property != undefined && this.property == "text"){
              cell.color = this.color
            }else{
              cell.color = this.color;
            }
            this.cellEditorStoreService.updateSelectedCell(cell);
          }) */
          break;
        case 'section':
          console.log("property: ", property);
          this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
            if (property != undefined && property == "background") {
              sectionData.bgColor = this.color;
              sectionData = { ...sectionData, bgColor: this.color }
              this.sectionEditorStoreService.updateSectionData(sectionData)
            } else {
              console.log("There is no property defined for section color change", this.color);
            }
          })
          // this.sectionEditorStoreService.setColor(this.color);
          break;
      }
    }
  }
  /**
   *
   * @param property can be background, border, text, content
   * @param content ContentElement to handle the color change for
   * @returns
   */
  handlePropertyColorChange(property: string, content: ContentElement): ContentElement {
    console.log("Handling property color change for: ", property, content);
    switch (property) {
      case "background":
        content = this.handleTarget("background", content)
        break;
      case "border":
        content = this.handleTarget("border", content)
        break;
      default:
        content = this.handleTarget("content", content);
        break;
    }
    return content
  }

  handleTarget(property: string, content: ContentElement): ContentElement {
    switch (this.target) {
      case "self":
        if (property == "background") {
          content.background = this.color;
        }
        if (property == "border") {
          content.borderColor = this.color;
        }
        if (property == "content") {
          content.color = this.color;
        }
        break;
      case "parent":
        if (property == "background") {
          content.parentBackground = this.color;
        }
        if (property == "border") {
          content.parentBorderColor = this.color;
        }
        break
      default:
        break;
    }
    return content;
  }

  updateBorderColor(borderString, color) {
    // Match hex colors (#fff, #ffffff), rgb/rgba, hsl/hsla, and named colors
    const colorPattern = /(#[0-9a-fA-F]{3,8}|rgba?\([^)]+\)|hsla?\([^)]+\)|[a-z]+)$/i;

    // Replace the last color value in the border string with the new color
    return borderString.replace(colorPattern, color);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
